import { useState, useMemo } from "react";
import { Dropdown, Checkbox } from "antd";
import { FilterOutlined, TagFilled, CloseOutlined } from "@ant-design/icons";
import { useAppSelector } from "@stores/redux/store";
import { getTagColorHex } from "@common";
import styles from "./styles.module.less";

interface ClassificationDropdownProps {
  selectedTagIds: string[];
  onTagsChange: (tagIds: string[]) => void;
}

export const ClassificationDropdown = ({
  selectedTagIds,
  onTagsChange,
}: ClassificationDropdownProps) => {
  const [open, setOpen] = useState(false);
  const { tags } = useAppSelector((state) => state.tags);

  const buttonText = useMemo(() => {
    if (selectedTagIds.length === 0) {
      return "Phân loại";
    }
    if (selectedTagIds.length === 1) {
      const selectedTag = tags.find((tag) => tag.id === selectedTagIds[0]);
      return selectedTag?.tagName || "Phân loại";
    }
    return `${selectedTagIds.length} thẻ`;
  }, [selectedTagIds, tags]);

  const dropdownContent = useMemo(
    () => {

      const handleTagToggle = (tagId: string, checked: boolean) => {
        if (checked) {
          onTagsChange([...selectedTagIds, tagId]);
        } else {
          onTagsChange(selectedTagIds.filter((id) => id !== tagId));
        }
      };

      return (
        <div className={styles.dropdownContent}>
          <div className={styles.section}>
            <div className={styles.sectionTitle}>Theo thẻ phân loại</div>
            <div className={styles.checkboxGroup}>
              {tags.map((tag) => {
                const isChecked = selectedTagIds.includes(tag.id);
                const tagColor = getTagColorHex(tag.id);
                return (
                  <div key={tag.id} className={styles.checkboxItem}>
                    <Checkbox
                      checked={isChecked}
                      onChange={(e) => handleTagToggle(tag.id, e.target.checked)}
                      className={styles.checkbox}
                    >
                      <div className={styles.tagLabel}>
                        <TagFilled style={{ color: tagColor }} />
                        <span className={styles.tagName}>{tag.tagName}</span>
                      </div>
                    </Checkbox>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    },
    [selectedTagIds, tags, onTagsChange]
  );

  const handleClearTags = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onTagsChange([]);
  };

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
      placement="bottomLeft"
      popupRender={() => dropdownContent}
      overlayClassName={styles.dropdown}
    >
      <button className={styles.triggerButton}>
        {selectedTagIds.length === 0 ? (
          <>
            <FilterOutlined />
            <span>{buttonText}</span>
          </>
        ) : (
          <>
            <span>{buttonText}</span>
            <CloseOutlined
              onClick={handleClearTags}
              className={styles.closeIcon}
            />
          </>
        )}
      </button>
    </Dropdown>
  );
};
